/**
 * Pagination — W1.2 (wiederverwendbar für W1.3, W1.5 etc.)
 *
 * Zeigt Prev/Next-Controls und Seitenanzeige.
 * Schreibt `page`-Parameter via onPageChange-Callback (Konsument schreibt URL).
 */
import { useTranslation } from 'react-i18next'

type Props = {
  page: number
  pages: number
  count: number
  onPageChange: (page: number) => void
}

export function Pagination({ page, pages, count, onPageChange }: Props) {
  const { t } = useTranslation('components')

  if (pages <= 1) return null

  const hasPrev = page > 1
  const hasNext = page < pages

  return (
    <nav
      className="pagination"
      role="navigation"
      aria-label={t('pagination.navAriaLabel')}
    >
      <button
        className="btn btn-ghost"
        disabled={!hasPrev}
        onClick={() => onPageChange(page - 1)}
        aria-label={t('pagination.prevAriaLabel')}
      >
        {t('pagination.prev')}
      </button>

      <span className="pagination-info" aria-live="polite">
        {t('pagination.pageInfo', { page, pages })}
        {count > 0 && <span className="muted"> {t('pagination.total', { count })}</span>}
      </span>

      <button
        className="btn btn-ghost"
        disabled={!hasNext}
        onClick={() => onPageChange(page + 1)}
        aria-label={t('pagination.nextAriaLabel')}
      >
        {t('pagination.next')}
      </button>
    </nav>
  )
}
